// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"46":"13151dcc","135":"50237863","252":"61e6170b","270":"b9b60069","276":"63c35ffc","279":"2d55e8b1","365":"b05ef9f8","372":"542df19e","525":"bec9fa74"}[chunkId] + ".chunk.js";
};